import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.trim.js";
import isEmail from 'validator/es/lib/isEmail';
import isUUID from 'validator/es/lib/isUUID';
import isHexColor from 'validator/es/lib/isHexColor';
import isHSL from 'validator/es/lib/isHSL';
import isJWT from 'validator/es/lib/isJWT';
import isHash from 'validator/es/lib/isHash';
import isBase64 from 'validator/es/lib/isBase64';
import isLowercase from 'validator/es/lib/isLowercase';
import isUppercase from 'validator/es/lib/isUppercase';
import isLength from 'validator/es/lib/isLength';
const validJwt = value => {
  if (!value) return true;
  return isJWT(value);
};
const validHsl = value => {
  if (!value) return true;
  return isHSL(value);
};
const validHash = (value, algorithm) => {
  if (!value) return true;
  return isHash(value, algorithm);
};
const validUuid = (value, version) => {
  if (!value) return true;
  return isUUID(value, version);
};
const validBase64 = (value, options) => {
  if (!value) return true;
  return isBase64(value, options);
};
const validEmail = (value, options) => {
  if (!value) return true;
  return isEmail(value, options);
};
const validHex = value => {
  if (!value) return true;
  return isHexColor(value);
};
const token = value => {
  if (!value) return true;
  return /^\w+$/.test(value);
};
const num = value => {
  if (!value) return true;
  return /^[0-9]+$/.test(value);
};
const alpha = value => {
  if (!value) return true;
  return /^[a-zA-ZÀ-ÿ]+$/.test(value);
};
const alphanum = value => {
  if (!value) return true;
  return /^[a-zA-Z0-9À-ÿ]+$/.test(value);
};
const noTrailingSpaces = value => {
  if (!value) return true;
  return Boolean(value.trim());
};
const lowercase = value => {
  if (!value) return true;
  return isLowercase(value);
};
const uppercase = value => {
  if (!value) return true;
  return isUppercase(value);
};
const length = (value, options) => {
  return isLength(value, options);
};
export const string = {
  validJwt,
  validHsl,
  validHash,
  validEmail,
  validUuid,
  validBase64,
  validHex,
  token,
  num,
  alpha,
  alphanum,
  noTrailingSpaces,
  lowercase,
  uppercase,
  length
};